import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";


const SingleLineChart = ({data}) => {
  return (
    <>
      
      <ResponsiveContainer height={200}>
        <LineChart
          width={500}
          height={100}
          data={data}
          syncId="anyId" 
          margin={{
            top: 0,
            right: 50,
            left: 30,
            bottom: 0,
          }}
        >
          <CartesianGrid horizontal={false} vertical={true} style={{color:'#E6E6E6'}}/>
          <XAxis dataKey="name" style={{fontSize:"10"}} />
          <YAxis style={{fontSize:"10"}} />
          <Tooltip />
          <Line type="monotone" dataKey="uv" stroke="#8884d8" strokeWidth={2} fill="#527DFF" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default SingleLineChart;
